<script>
import { Modal, Dropdown } from "bootstrap";
import CurrencyInput from "@/components/CurrencyInput";
// import debitCashAccounts from '@/components/debitCashAccounts.vue'
export default {
  page: {},
  components: { CurrencyInput },
  props: { fixed_asset: Object },
  data() {
    return {
      addPayAccounts: [{}],
      disposed_asset: {},
      dispose_modal: null,
      re_evalute_modal: null,
      edit_modal: null,
      register_modal: null,
      remaining_value: 0,
      fixedAssetProduct: {},
      revaluation_asset: {},
      registerAsset: [{}],
      // end global data
      fixedAssets: [],
      cash_accounts: [],
      typesOptions: [],
      cashAccounts: [],
      addAsset: [{}],
      // totalValue: 0,
      page: 1,
      limit: 20,
      tot_pages: 0,
      SearchMode: false,
      search: "",
      // payment process data
      isOnCredit: true,
      selectedPaymentType: "",
      paymentTypes: [
        { id: 1, name: "مديونية", name_en: "Pay On Credit" },
        { id: 2, name: "دفع جزئي", name_en: "Partial Payment" },
        { id: 3, name: "دفع كامل", name_en: "Full Payment" },
      ],
      previous_payable: 0,
      prepayment: 0,
      due_date: null,
      is_du_time: false,
      // agent auto complete data :
      agents: [],
      purchase_item_type: {},
      revaluate_value: {},
      currency: {},
      asset_revaluation_log_modal: {},
      revaluation_logs: [],
      log_page: 1,
      log_limit: 20,
      log_tot: 0,
      log_search: "",
      fixed_asset_disposal_types: [],
      disposal_type_code: {},
      add_custody_modal: {},
      fixed_asset_product: {},
      hr_custody: {},
      fixed_assets: [],
      company_branches: [],
      emps: [],
      branch_sites: [],
      transfer_modal: {},
      transfer_data: {},
      transfer_hr_custody_modal: {},
      data: {},
      dropdown: {},
      filter: "all",
      reference_no: "",
      AssetStatuses: []
      // appprices:[]
    };
  },

  computed: {
    totalDisposalAccountsValue() {
      return this.addAsset
        .filter((account) => account?.cash_account?.id && account.value)
        .reduce((sum, account) => sum + account.value, 0);
    },
  },
  methods: {
    getPurchaseConfigurations() {
      this.http.get("purchases/configurations").then((res) => {
        this.cash_accounts = res.cash_accounts;
      });
    },

    searchFixedAssetProducts(page) {
      if (this.search.length == 0) return this.cancelFixedAssetsSearchMode();

      this.SearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("fixed-assets/fixed-asset-products/search", {
          search: this.search,
          page,
          limit: this.limit,
          fixed_asset_id: this.$route.params.id,
          filter: this.filter,
        })
        .then((res) => {
          if (res.status) {
            this.page = page;
            this.tot_pages = Math.ceil(res.tot / this.limit);
            this.fixedAssets = res.data;
          }
        });
    },
    cancelFixedAssetsSearchMode() {
      this.search = "";
      this.SearchMode = false;
      this.getFixedAssetProductsPagination(this.page);
    },
    registerFixedAssetProduct() {
      console.log(this.registerAsset);
      this.registerAsset.forEach((asset) => {
        asset.fixed_asset_id = this.$route.params.id;
        asset.fixed_asset_type_id = this.fixed_asset?.fixed_asset_type_id;
        asset.fixed_asset_name = this.fixed_asset?.name;
        asset.fixed_asset_name_en = this.fixed_asset?.name_en;
      });

      console.log("step 184: ", this.registerAsset);

      this.http
        .post("transactions/register-asset-products", {
          asset_products: this.registerAsset,
          reference_no: this.reference_no,
        })
        .then((res) => {
          if (res.status) {
            this.registerAsset = [{}];
            this.getFixedAssetProductsPagination(this.page);
            this.register_modal.hide();
          }
        });
    },

    preEditFixedAsset(fixedAsset) {
      this.fixedAssetProduct = JSON.parse(JSON.stringify(fixedAsset));
      this.fixedAssetProduct.depreciable = this.fixedAssetProduct.depreciable
        ? true
        : false;
      this.fixedAssetProduct.under_warranty = this.fixedAssetProduct
        .under_warranty
        ? true
        : false;
      this.edit_modal.show();
    },

    editFixedAsset() {
      this.http
        .put(
          "fixed-assets/fixed-asset-product",
          this.fixedAssetProduct.id,
          this.fixedAssetProduct
        )
        .then((res) => {
          if (res.status) {
            this.getFixedAssetProductsPagination(this.page);
            this.edit_modal.hide();
            this.$swal.fire(this.$t("messages.success"));
          }
        });
    },

    getFixedAssetProductsPagination(page) {
      this.http
        .post("fixed-assets/fixed-asset-products/pagination", {
          limit: this.limit,
          page: page,
          fixed_asset_id: this.$route.params.id,
          filter: this.filter,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          console.log(this.tot_pages);
          this.fixedAssets = res.data;
          console.log("this.fixedAssets", this.fixedAssets);
        });
    },
    getAccounts() {
      this.http.post("transactions/cash-accounts", {}).then((resp) => {
        this.cashAccounts = resp.data;
      });
    },

    doDispose() {
      this.http
        .post("fixed-assets/fixed-asset-product/disposal", {
          id: this.disposed_asset.id,
          name: this.fixed_asset?.name,
          name_en: this.fixed_asset?.name_en,
          serial_no: this.disposed_asset?.serial_no,
          remaining_value: this.remaining_value,
          fixed_asset_type_id: this.disposed_asset.fixed_asset_type_id,
          initial_book_value: this.disposed_asset.revaluted_book_value
            ? this.disposed_asset.revaluted_book_value
            : this.disposed_asset.initial_book_value,
          accounts: this.addAsset,
          disposal_type_code: this.disposal_type_code,
        })
        .then((res) => {
          if (res.status) {
            this.dispose_modal.hide();
            this.getFixedAssetProductsPagination(this.page);
            this.$swal.fire(this.$t("messages.success"));
          }
        });
    },

    sellFixedAssetProduct(asset) {
      this.disposed_asset = asset;
      console.log("step 209 :", asset);
      this.http
        .post("fixed-assets/process-disposal", { id: asset.id })
        .then((res) => {
          console.log(res.status);
          this.remaining_value = res.data?.remaining_value;
          this.addAsset = [{}];
          this.getAccounts();
          this.dispose_modal.show();
        });
    },

    preReEvaluteAsset(fixedAsset) {
      this.revaluation_asset = JSON.parse(JSON.stringify(fixedAsset));
      this.revaluation_asset.initial_book_value = this.revaluation_asset
        ?.revaluted_book_value
        ? this.revaluation_asset?.revaluted_book_value
        : this.revaluation_asset?.initial_book_value;
      this.revaluation_asset.salvage_value = this.revaluation_asset
        ?.revaluted_salvage_value
        ? this.revaluation_asset?.revaluted_salvage_value
        : this.revaluation_asset?.salvage_value;
      this.revaluation_asset.replacement_cost = this.revaluation_asset
        ?.revaluted_replacement_cost
        ? this.revaluation_asset?.revaluted_replacement_cost
        : this.revaluation_asset?.replacement_cost;
      this.revaluation_asset.installation_date = this.revaluation_asset
        ?.revaluted_installation_date
        ? this.revaluation_asset?.revaluted_installation_date
        : this.revaluation_asset?.installation_date;
      this.revaluation_asset.useful_life_years = this.revaluation_asset
        ?.revaluted_useful_life_years
        ? parseFloat(this.revaluation_asset.revaluted_useful_life_years)
        : parseFloat(this.revaluation_asset?.useful_life_years);
      this.re_evalute_modal.show();
    },
    reEvaluteAsset() {
      console.log(this.revaluation_asset);
      console.log(this.revaluate_value);
      if (!this.revaluate_value.revaluted_book_value)
        return this.popup.alert({
          title: "popups.error",
          msg: "fixed_assets.enter_book_value",
        });
      this.http
        .post("fixed-assets/fixed-asset-product/revaluate-asset", {
          fixed_asset_product: this.revaluation_asset,
          values: this.revaluate_value,
        })
        .then((res) => {
          if (res.status) {
            this.getFixedAssetProductsPagination(this.page);
            this.re_evalute_modal.hide();
          }
        });
    },
    preAssetRevaluationLog(record) {
      this.fixedAssetProduct = Object.assign({}, record);
      this.getRevaluationLogs(1);
      this.asset_revaluation_log_modal.show();
    },
    getRevaluationLogs(page) {
      this.http
        .post("fixed-assets/revaluation-logs/pagination", {
          page,
          limit: this.log_limit,
          fixed_asset_product_id: this.fixedAssetProduct.id,
        })
        .then((res) => {
          if (res.status) {
            (this.log_page = page),
              (this.log_tot = Math.ceil(res.tot / this.log_limit));
            this.revaluation_logs = res.data;
          }
        });
    },
    searchRevaluationLogs(page) {
      if (!this.log_search.length) return this.getRevaluationLogs(1);

      this.http
        .post("fixed-assets/revaluation-logs/search", {
          search: this.log_search,
          page,
          limit: this.log_limit,
          fixed_asset_product_id: this.fixedAssetProduct.id,
        })
        .then((res) => {
          if (res.status) {
            (this.log_page = page),
              (this.log_tot = Math.ceil(res.tot / this.log_limit));
            this.revaluation_logs = res.data;
          }
        });
    },
    getFixedAssetDisposalTypes() {
      this.http.get("fixed-asset-disposal-types").then((res) => {
        if (res.status) this.fixed_asset_disposal_types = res.data;
        if (this.fixed_asset_disposal_types.length)
          this.disposal_type_code = this.fixed_asset_disposal_types[0].code;
      });
    },
    openHrCustodiesModalForFixedAsset(fixed_asset_product) {
      this.hr_custody = {
        fixed_asset_product,
      };
      this.fixed_asset_product = fixed_asset_product;
      this.add_custody_modal.show();
    },
    addHrCustody() {
      this.http
        .post("emp-custodies", {
          fixed_asset_product_id: this.hr_custody?.fixed_asset_product?.id,
          emp_id: this.hr_custody?.emp?.id,
          reference_no: this.hr_custody.reference_no,
        })
        .then((res) => {
          if (res.status) {
            this.add_custody_modal.hide();
            this.getFixedAssetProductsPagination(this.page);
            this.hr;
          }
        });
    },
    searchFixedAssetsForCustody(search) {
      console.log("product :", this.product);

      this.http
        .post(
          "emp-custodies/search-fixed-asset-products",
          { search },
          null,
          true
        )
        .then((res) => {
          if (res.status) {
            this.fixed_assets = res.data;
          }
        });
    },
    showLabel(one) {
      return (
        (this.$i18n.locale == "en" ? one?.name_en : one?.name) +
        " - " +
        one?.serial_no
      );
    },
    searchEmployees(search) {
      this.http
        .post(
          "emp-custodies/search-emps",
          {
            search,
            limit: 25,
            current_emp_id: this.hr_custody.under_custody[0]?.emp_id,
          },
          null,
          true
        )
        .then((res) => {
          if (res.status) {
            this.emps = res.data;
          }
        });
    },
    showEmpLabel(one) {
      return one.name;
    },
    deleteHrCustody(app) {
      console.log(app);
      var data = {
        title: "hr_custodies.delete_custody",
        inputs: [
          {
            model: "reference_no",
            type: "text",
            label: "fixed_assets.reference_no",
          },
        ],
        buttons: [
          {
            text: "release",
            closer: true,
            color: "primary",
            handler: (obj) => {
              console.log("###");
              this.http
                .delete("emp-custodies", app.id, {
                  reference_no: obj.reference_no,
                })
                .then((res) => {
                  if (res.status)
                    this.getFixedAssetProductsPagination(this.page);
                });
            },
          },
          {
            text: "Cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    getBranches() {
      this.http.get("branches").then((res) => {
        if (res.status) this.company_branches = res.data;
      });
    },
    getBranchSites(branch_id, index) {
      this.registerAsset[index].branch_site_id = null;
      this.http
        .post("level-one-chart-of-accounts/get-branch-sites", { branch_id })
        .then((resp) => {
          console.log(resp.data);
          this.branch_sites = resp.data;
          this.registerAsset[index].branch_sites = resp.data;
        });
    },
    getBranchSitesTransfer(branch_id) {
      this.transfer_data.branch_site_id = null;
      this.http
        .post("level-one-chart-of-accounts/get-branch-sites", { branch_id })
        .then((resp) => {
          console.log(resp.data);
          this.branch_sites = resp.data;
        });
    },
    transferAsset(asset) {
      let locale = this.$i18n.locale;
      let self = this;
      this.http
        .post("branches/execlude", { asset_branch_id: asset.branch_id })
        .then((res) => {
          this.branches = res.data;
          var data = {
            title: "fixed_assets.transfer",
            inputs: [
              {
                model: "to_branch_id",
                type: "select",
                options: (() => {
                  return this.branches.map((data) => {
                    return {
                      value: data.id,
                      label: locale == "ar" ? data.name : data.name_en,
                    };
                  });
                })(),
                label: "fixed_assets.transfer_to",
              },
            ],
            buttons: [
              {
                text: "fixed_assets.transfer",
                closer: true,
                color: "primary",
                handler: (obj) => {
                  obj.from_branch_id = asset.branch_id;
                  this.http
                    .put("fixed-assets/transfer", asset.id, obj)
                    .then((res) => {
                      self.branches = res.data;
                      self.getFixedAssetProductsPagination(self.page);
                    });
                },
              },
              {
                text: "Cancel",
                closer: true,
                color: "danger",
                handler: () => {
                  console.log("Like Clicked");
                },
              },
            ],
          };
          this.popup.modal(data);
        });
    },
    preTransfer(asset) {
      console.log(asset);
      this.transfer_data = {
        id: asset.id,
        from_branch_id: asset?.branch_id,
      };
      this.http
        .post("branches/execlude", { asset_branch_id: asset.branch_id })
        .then((res) => {
          if (res.status) this.company_branches = res.data;
        });

      this.transfer_modal.show();
    },
    doTransfer() {
      this.http
        .put(
          "fixed-assets/fixed-asset-product/transfer",
          this.transfer_data.id,
          this.transfer_data
        )
        .then((res) => {
          if (res.status) {
            this.getFixedAssetProductsPagination(this.page);
            this.transfer_modal.hide();
          }
        });
    },
    openTransferHrCustodyModal(data) {
      this.hr_custody = JSON.parse(JSON.stringify(data));
      this.transfer_hr_custody_modal.show();
    },
    transferHrCustody() {
      console.log("data :", {
        reference_no: this.hr_custody.reference_no,
        emp: this.hr_custody.emp,
        fixed_asset_product: {
          id: this.hr_custody.id,
          name: this.hr_custody.name,
          name_en: this.hr_custody.name_en,
          serial_no: this.hr_custody?.serial_no,
        },
      });

      this.http
        .put(
          "emp-custodies/transfer-asset-custody",
          this.hr_custody.under_custody[0].id,
          {
            reference_no: this.hr_custody.reference_no,
            emp: this.hr_custody.emp,
            fixed_asset_product: {
              id: this.hr_custody.id,
              name: this.hr_custody.name,
              name_en: this.hr_custody.name_en,
              serial_no: this.hr_custody?.serial_no,
            },
          }
        )
        .then((res) => {
          if (res.status) {
            this.popup.alert({
              title: "popups.done",
              msg: res.msg,
            });
            this.transfer_hr_custody_modal.hide();
            this.getFixedAssetProductsPagination(this.page);
          }
        });
    },
    getAssetStatuses() {
      this.http.get("fixed-assets/asset-statuses").then((res) => {
        this.AssetStatuses = res.data;
      });
    },

    getBranchSubSites(branch_site_id, index) {
      this.registerAsset[index].branch_sub_site_id = null;
      this.http.get('level-one-chart-of-accounts/branch-sub-sites/' + branch_site_id).then(resp => {
        this.registerAsset[index].branch_sub_sites = resp.data;
      });
    },
  },
  // end

  mounted() {
    console.log("fixed_asset :", this.fixed_asset);

    // const current_user = JSON.parse(localStorage.pos_station);
    // this.pos_station_id = current_user.pos_station_id;
    this.getFixedAssetProductsPagination(1);
    this.getAccounts();
    this.getFixedAssetDisposalTypes();

    this.getPurchaseConfigurations();
    this.getBranches();
    this.getAssetStatuses()
    this.dropdown = new Dropdown(".dropdown-toggle.filter-stock");

    this.re_evalute_modal = new Modal("#reEvaluteModal");
    this.dispose_modal = new Modal("#disposeModal");
    this.edit_modal = new Modal("#editModal");
    this.register_modal = new Modal("#registerModal");
    this.asset_revaluation_log_modal = new Modal("#assetRevaluationLogModal");
    this.add_custody_modal = new Modal("#hrCustodyModal");
    this.transfer_modal = new Modal("#transferModal");
    this.transfer_hr_custody_modal = new Modal("#transferHrCustodyModal");
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-6 mb-4">
              <div class="search-box chat-search-box w-50">
                <div class="position-relative">
                  <input @input="searchFixedAssetProducts(page)" type="search" class="form-control fa-lg text-light"
                    :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" :placeholder="$t('popups.search')" v-model="search"
                    style="background-color: #2a3042 !important" />
                </div>
              </div>
            </div>
            <div class="col-6" style="display: flex; justify-content: flex-end">
              <div class="">
                <div>
                  <div class="position-relative">
                    <input type="text" :value="$t('fixed_assets.' + filter)" class="form-control" readonly />
                  </div>
                </div>
              </div>
              <div class="">
                <div class="dropdown">
                  <button class="btn btn-light dropdown-toggle filter-stock" @click="dropdown.toggle"
                    data-bs-toggle="dropdown">
                    <span class="fa fa-filter"></span>
                  </button>
                  <ul class="dropdown-menu" style="z-index: 100">
                    <li>
                      <a href="javascript: void(0)" class="dropdown-item" @click="
                        filter = 'all';
                      search
                        ? searchFixedAssetProducts(page)
                        : getFixedAssetProductsPagination(page);
                      ">{{ $t("fixed_assets.all") }}</a>
                    </li>
                    <li>
                      <a href="javascript: void(0)" class="dropdown-item" @click="
                        filter = 'through_suppliers';
                      search
                        ? searchFixedAssetProducts(page)
                        : getFixedAssetProductsPagination(page);
                      ">{{ $t("fixed_assets.through_suppliers") }}</a>
                    </li>
                    <li>
                      <a href="javascript: void(0)" class="dropdown-item" @click="
                        filter = 'through_donations';
                      search
                        ? searchFixedAssetProducts(page)
                        : getFixedAssetProductsPagination(page);
                      ">{{ $t("fixed_assets.through_donations") }}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <button type="button" @click="
                register_modal.show();
              reference_no = '';
              this.getBranches();
              " class="btn btn-secondary float-end mb-4 mx-2">
                {{ $t("fixed_assets.register") }}
              </button>
            </div>
          </div>
          <div class="table-responsive">
            <table style="table-layout: auto"
              class="table table-centered table-nowrap table-striped table-hover align-middle">
              <thead class="ant-table-thead">
                <tr class="text-light text-center" style="background-color: #2a3042 !important">
                  <th class=" ">#</th>
                  <th scope="col">{{ $t("fixed_assets.code") }}</th>
                  <th scope="col">{{ $t("fixed_assets.asset_status") }}</th>
                  <th class=" ">
                    <span class="ant-table-column-title">{{ $t("fixed_assets.serial_no") }}
                    </span>
                  </th>
                  <th scope="col">{{ $t("fixed_assets.alt_name") }}</th>
                  <th scope="col">{{ $t("fixed_assets.alt_name_en") }}</th>
                  <th scope="col">{{ $t("fixed_assets.supplier") }}</th>
                  <th scope="col">{{ $t("fixed_assets.donator") }}</th>
                  <th scope="col">{{ $t("emps.branch") }}</th>
                  <th scope="col">{{ $t("fixed_assets.branch_site") }}</th>
                  <th scope="col">{{ $t("fixed_assets.branch_sub_site") }}</th>

                  <th scope="col">{{ $t("fixed_assets.under_custody") }}</th>

                  <th class=" ">
                    <span class="ant-table-column-title">{{ $t("fixed_assets.initial") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title">{{ $t("fixed_assets.revaluted_book_value") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title">{{ $t("fixed_assets.salvage_value") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title">{{ $t("fixed_assets.revaluted_salvage_value") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title">{{ $t("fixed_assets.replacement_cost ") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title">{{ $t("fixed_assets.revaluted_replacement_cost") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title">{{ $t("fixed_assets.depreciable") }}
                    </span>
                  </th>
                  <!-- <th scope="col">{{ $t("fixed_assets.rate") }}</th> -->

                  <th class=" ">
                    {{ $t("fixed_assets.installation_date") }}
                  </th>
                  <th class=" ">
                    {{ $t("fixed_assets.revaluted_installation_date") }}
                  </th>
                  <th class=" ">
                    {{ $t("fixed_assets.useful_life_years") }}
                  </th>
                  <th class=" ">
                    {{ $t("fixed_assets.revaluted_useful_life_years") }}
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title">{{ $t("fixed_assets.under_warranty") }}
                    </span>
                  </th>
                  <th class=" ">
                    <span class="ant-table-column-title">{{ $t("fixed_assets.warranty_exp") }}
                    </span>
                  </th>

                  <th class=" ">
                    <span class="ant-table-column-title">{{ $t("fixed_assets.additional_descr") }}
                    </span>
                  </th>

                  <th class=" ">
                    <span class="ant-table-column-title">{{ $t("fixed_assets.comment") }}
                    </span>
                  </th>
                  <th scope="col">{{ $t("fixed_assets.rhh") }}</th>
                  <th scope="col">Pof</th>
                  <th scope="col">Cof</th>
                  <th scope="col">{{ $t("fixed_assets.r_f") }}</th>
                  <th scope="col">{{ $t("fixed_assets.risk_score") }}</th>
                  <th class=" ">
                    <span class="ant-table-column-title">{{ $t("fixed_assets.operations") }}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody class="ant-table-tbody">
                <tr :title="($i18n.locale == 'ar'
                  ? fixedAsset?.name
                  : fixedAsset?.name_en) +
                  ' - ' +
                  fixedAsset?.serial_no
                  " v-for="(fixedAsset, index) in fixedAssets" :key="index"
                  class="ant-table-row text-center ant-table-row-level-0">
                  <td>{{ (page - 1) * this.limit + index + 1 }}</td>
                  <td class=" ">
                    {{ fixedAsset?.code }}
                  </td>
                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.asset_status_name
                        : fixedAsset?.asset_status_name_en
                    }}
                  </td>
                  <td class=" ">
                    {{ fixedAsset?.serial_no }}
                  </td>
                  <td>
                    {{ fixedAsset?.alt_name }}
                  </td>
                  <td>
                    {{ fixedAsset?.alt_name_en }}
                  </td>
                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.agent_name
                        : fixedAsset?.agent_name_en
                    }}
                  </td>
                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.donator_name
                        : fixedAsset?.donator_name_en
                    }}
                  </td>
                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.branch_name
                        : fixedAsset?.branch_name_en
                    }}
                  </td>
                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.branch_site_name
                        : fixedAsset?.branch_site_name_en
                    }}
                  </td>
                  <td>
                    {{
                      $i18n.locale == "ar"
                        ? fixedAsset?.branch_sub_site_name
                        : fixedAsset?.branch_sub_site_name_en
                    }}
                  </td>
                  <td>
                    {{
                      fixedAsset?.under_custody &&
                        fixedAsset?.under_custody?.length
                        ? fixedAsset?.under_custody[0]?.emp_name
                        : ""
                    }}
                  </td>

                  <td class=" ">
                    {{
                      parseFloat(
                        fixedAsset?.initial_book_value
                      ).toLocaleString()
                    }}
                  </td>
                  <td class=" ">
                    {{
                      fixedAsset?.revaluted_book_value
                        ? parseFloat(
                          fixedAsset?.revaluted_book_value
                        ).toLocaleString()
                        : "-"
                    }}
                  </td>
                  <td class=" ">
                    {{ parseFloat(fixedAsset?.salvage_value).toLocaleString() }}
                  </td>
                  <td class=" ">
                    {{
                      fixedAsset?.revaluted_salvage_value
                        ? parseFloat(
                          fixedAsset?.revaluted_salvage_value
                        ).toLocaleString()
                        : "-"
                    }}
                  </td>
                  <td class=" ">
                    {{
                      parseFloat(fixedAsset?.replacement_cost).toLocaleString()
                    }}
                  </td>
                  <td class=" ">
                    {{
                      fixedAsset?.revaluted_replacement_cost
                        ? parseFloat(
                          fixedAsset?.revaluted_replacement_cost
                        ).toLocaleString()
                        : "-"
                    }}
                  </td>
                  <td class=" ">
                    {{
                      fixedAsset?.depreciable
                        ? $t("fixed_assets.yes")
                        : $t("fixed_assets.no")
                    }}
                  </td>
                  <!--<td>
                    {{
                      fixedAsset?.depreciation_rate
                        ? fixedAsset?.depreciation_rate
                        : "-"
                    }}
                  </td> -->
                  <td class=" ">
                    {{ fixedAsset?.installation_date }}
                  </td>
                  <td class=" ">
                    {{
                      fixedAsset?.revaluted_installation_date
                        ? fixedAsset?.revaluted_installation_date
                        : "-"
                    }}
                  </td>
                  <td class=" ">
                    {{
                      fixedAsset?.useful_life_years
                        ? parseFloat(fixedAsset?.useful_life_years)
                        : "-"
                    }}
                  </td>
                  <td class=" ">
                    {{
                      fixedAsset?.revaluted_useful_life_years
                        ? parseFloat(fixedAsset?.useful_life_years)
                        : "-"
                    }}
                  </td>

                  <td class=" ">
                    {{
                      fixedAsset?.under_warranty
                        ? $t("fixed_assets.yes")
                        : $t("fixed_assets.no")
                    }}
                  </td>
                  <td class=" ">
                    {{ fixedAsset?.warranty_exp }}
                  </td>

                  <td class=" ">
                    {{ fixedAsset?.additional_descr }}
                  </td>
                  <td class=" ">
                    {{ fixedAsset?.comment }}
                  </td>
                  <td>{{ fixedAsset?.rhh }}</td>
                  <td>{{ fixedAsset?.pof }}</td>
                  <td>{{ fixedAsset?.cof }}</td>
                  <td>{{ fixedAsset?.r_f }}</td>
                  <td>{{ fixedAsset?.risk_score }}</td>
                  <td class="d-flex">
                    <router-link style="margin-inline-end: 4px" :to="{
                      name: 'fixed-asset-product-profile',
                      params: {
                        id: fixedAsset?.fixed_asset_id,
                        fixed_asset_product_id: fixedAsset?.id,
                      },
                    }">
                      <button class="btn btn-info" role="button" data-toggle="tooltip" data-placement="top" :title="$i18n.locale == 'ar'
                        ? fixedAsset.name
                        : fixedAsset.name_en +
                        ' - ' +
                        fixedAsset.serial_no +
                        ' ' +
                        $t('fixed_assets.profile')
                        ">
                        <i class="bx bxs-detail"></i>
                      </button>
                    </router-link>
                    <button type="button" @click="openHrCustodiesModalForFixedAsset(fixedAsset)" class="btn btn-primary"
                      style="margin-inline-end: 4px" v-if="
                        !(
                          fixedAsset?.under_custody &&
                          fixedAsset?.under_custody[0]?.id
                        )
                      ">
                      {{ $t("hr_custodies.add_asset_custody") }}
                    </button>
                    <a v-if="
                      fixedAsset.under_custody &&
                      fixedAsset.under_custody[0]?.id
                    " class="btn btn-danger" style="margin-inline-end: 4px" href="javascript: void(0);" role="button"
                      @click="deleteHrCustody(fixedAsset.under_custody[0])">{{ $t("hr_custodies.delete_custody") }}</a>
                    <a v-if="
                      fixedAsset.under_custody &&
                      fixedAsset.under_custody[0]?.id
                    " class="btn btn-primary" style="margin-inline-end: 4px" href="javascript: void(0);" role="button"
                      @click="openTransferHrCustodyModal(fixedAsset)">{{
                        $t("hr_custodies.transfer_custody") }}</a>

                    <a v-if="!fixedAsset.under_custody" style="margin-inline-end: 4px" class="btn btn-primary btn-md"
                      @click="preTransfer(fixedAsset)" role="button">{{ $t("fixed_assets.transfer") }}</a>

                    <a style="margin-inline-end: 4px" class="btn btn-primary btn-md"
                      @click="preReEvaluteAsset(fixedAsset)" role="button">
                      {{ $t("fixed_assets.asset_revaluation") }}
                      <!-- <i class='fa fa-recycle'></i> -->
                    </a>
                    <button style="margin-inline-end: 4px" class="btn btn-primary btn-md"
                      @click="preAssetRevaluationLog(fixedAsset)">
                      {{ $t("fixed_assets.asset_revaluation_log") }}
                    </button>
                    <a v-if="
                      !(
                        fixedAsset.under_custody &&
                        fixedAsset.under_custody[0]?.id
                      )
                    " style="margin-inline-end: 4px" class="btn btn-primary btn-md"
                      @click="sellFixedAssetProduct(fixedAsset)" role="button">
                      {{ $t("fixed_assets.disposal") }}
                    </a>
                    <a style="margin-inline-end: 4px" class="btn btn-primary btn-md"
                      @click="preEditFixedAsset(fixedAsset)" role="button">{{ $t("popups.edit") }}</a>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- end  table -->

    <!--end-->

    <!-- Modal Body -->
    <!-- if you want to close by clicking outside the modal, delete the last endpoint:data-bs-backdrop and data-bs-keyboard -->
    <div class="modal fade" id="assetRevaluationLogModal" tabindex="-1" role="dialog" aria-labelledby="modalTitleId"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalTitleId">
              {{ $t("fixed_assets.asset_revaluation_log") }} /
              {{
                this.$i18n.locale == "en"
                  ? fixedAssetProduct.name_en
                  : fixedAssetProduct.name
              }}
              - {{ fixedAssetProduct.serial_no }}
            </h5>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <div class="row">
                <div class="col-6 mb-4">
                  <div class="search-box chat-search-box w-50">
                    <div class="position-relative">
                      <input @input="searchRevaluationLogs(log_page)" type="search"
                        class="form-control fa-lg text-light" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                        :placeholder="$t('popups.search')" v-model="log_search"
                        style="background-color: #2a3042 !important" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table style="table-layout: auto"
                  class="table table-centered table-nowrap table-striped table-hover align-middle">
                  <thead class="ant-table-thead">
                    <tr class="text-light text-center" style="background-color: #2a3042 !important">
                      <th class=" ">#</th>

                      <th class=" ">
                        <span class="ant-table-column-title">{{
                          $t("fixed_assets.revaluation_log.revaluation_date")
                        }}
                        </span>
                      </th>
                      <th class=" ">
                        <span class="ant-table-column-title">{{ $t("fixed_assets.reference_no") }}
                        </span>
                      </th>
                      <th class=" ">
                        <span class="ant-table-column-title">{{
                          $t("fixed_assets.revaluation_log.from_book_value")
                        }}
                        </span>
                      </th>
                      <th class=" ">
                        <span class="ant-table-column-title">{{
                          $t("fixed_assets.revaluation_log.to_book_value")
                        }}
                        </span>
                      </th>
                      <th class=" ">
                        <span class="ant-table-column-title">{{
                          $t(
                            "fixed_assets.revaluation_log.from_salvage_value"
                          )
                        }}
                        </span>
                      </th>

                      <th class=" ">
                        <span class="ant-table-column-title">{{
                          $t("fixed_assets.revaluation_log.to_salvage_value")
                        }}
                        </span>
                      </th>

                      <th class=" ">
                        <span class="ant-table-column-title">{{
                          $t(
                            "fixed_assets.revaluation_log.from_replacement_cost"
                          )
                        }}
                        </span>
                      </th>

                      <th class=" ">
                        <span class="ant-table-column-title">{{
                          $t(
                            "fixed_assets.revaluation_log.to_replacement_cost"
                          )
                        }}
                        </span>
                      </th>

                      <th class=" ">
                        {{
                          $t(
                            "fixed_assets.revaluation_log.from_useful_life_years"
                          )
                        }}
                      </th>

                      <th class=" ">
                        {{
                          $t(
                            "fixed_assets.revaluation_log.to_useful_life_years"
                          )
                        }}
                      </th>

                      <th class=" ">
                        {{
                          $t(
                            "fixed_assets.revaluation_log.from_installation_date"
                          )
                        }}
                      </th>

                      <th class=" ">
                        {{
                          $t(
                            "fixed_assets.revaluation_log.to_installation_date"
                          )
                        }}
                      </th>
                    </tr>
                  </thead>

                  <tbody class="ant-table-tbody">
                    <tr :title="$i18n.locale == 'ar'
                      ? fixedAsset?.name
                      : fixedAsset?.name_en
                      " v-for="(log, index) in revaluation_logs" :key="index"
                      class="ant-table-row text-center ant-table-row-level-0">
                      <td>{{ index + 1 }}</td>
                      <td class=" ">
                        {{ new Date(log?.created).toLocaleString("en-GB") }}
                      </td>
                      <td class=" ">
                        {{ log.reference_no }}
                      </td>

                      <td class=" ">
                        {{ parseFloat(log?.from_book_value).toLocaleString() }}
                      </td>
                      <td class=" ">
                        {{ parseFloat(log?.to_book_value).toLocaleString() }}
                      </td>

                      <td class=" ">
                        {{
                          parseFloat(log?.from_salvage_value).toLocaleString()
                        }}
                      </td>
                      <td class=" ">
                        {{ parseFloat(log?.to_salvage_value).toLocaleString() }}
                      </td>
                      <td class=" ">
                        {{
                          parseFloat(
                            log?.from_replacement_cost
                          ).toLocaleString()
                        }}
                      </td>
                      <td class=" ">
                        {{
                          parseFloat(log?.to_replacement_cost).toLocaleString()
                        }}
                      </td>

                      <td class=" ">
                        {{ log?.from_useful_life_years }}
                      </td>

                      <td class=" ">
                        {{ log?.to_useful_life_years }}
                      </td>

                      <td class=" ">
                        {{ log?.from_installation_date }}
                      </td>
                      <td class=" ">
                        {{ log?.to_installation_date }}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div>
                  <ul class="pagination pagination-rounded justify-content-center mb-2">
                    <li class="page-item" :class="{ disabled: log_page > 0 }">
                      <a class="page-link" href="javascript: void(0);" @click="getRevaluationLogs(log_page - 1)"
                        aria-label="Previous">
                        <i class="mdi mdi-chevron-left"></i>
                      </a>
                    </li>
                    <li class="page-item" :class="{ active: p == log_page }" v-for="p in log_tot" :key="p">
                      <a class="page-link" href="javascript: void(0);" @click="getRevaluationLogs(p)">{{ p }}</a>
                    </li>

                    <li class="page-item" :class="{ disabled: log_page == log_tot }">
                      <a class="page-link" href="javascript: void(0);" @click="getRevaluationLogs(log_page + 1)"
                        aria-label="Next">
                        <i class="mdi mdi-chevron-right"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
              @click="asset_revaluation_log_modal.hide()">
              {{ $t("popups.colse") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--Start register Modal-->
    <div class="modal fade" id="registerModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <form @submit.prevent="registerFixedAssetProduct()">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                {{ $t("fixed_assets.register") }}
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                style="margin: 0"></button>
            </div>

            <div class="modal-body">
              <div class="row">
                <div class="col-12 col-md-6">
                  <label for="asset_id">{{
                    $t("fixed_assets.reference_no")
                  }}</label>
                  <input type="text" v-model="reference_no" class="form-control mb-2 mx-1"
                    :placeholder="$t('fixed_assets.reference_no')" />
                </div>
              </div>
              <div class="row">
                <div class="d-flex justify-content-end">
                  <div>
                    <button type="button" @click="registerAsset.push({})" class="btn">
                      <span class="bx bxs-plus-circle fa-2x" style="color: #2a3042 !important"></span>
                    </button>
                  </div>
                </div>
                <div class="my-2 row" v-for="(asset_product, index) in registerAsset" :key="index">
                  <div class="col-6"></div>
                  <div class="col-6 mt-3">
                    <button type="button" :disabled="registerAsset.length == 1" @click="registerAsset.splice(index, 1)"
                      class="btn btn-danger float-end">
                      <span class="bx bxs-trash" style="color: #fff !important"></span>
                    </button>
                  </div>
                  <div class="col-12 col-md-4">
                    <label for="asset_id">{{ $t("emps.branch") }}</label>
                    <select class="form-select" v-model="asset_product.branch_id"
                      @change="getBranchSites(asset_product.branch_id, index)">
                      <option v-for="branch in company_branches" :key="branch" :value="branch.id">
                        {{
                          $i18n.locale == "en" ? branch.name_en : branch.name
                        }}
                      </option>
                    </select>
                  </div>

                  <div class="col-12 col-md-4">
                    <div class="">
                      <label for="asset_id">{{
                        $t("fixed_assets.branch_site")
                      }}</label>
                      <select class="form-select" v-model="asset_product.branch_site_id"
                        @change="getBranchSubSites(asset_product.branch_site_id, index)">
                        <option v-for="site in asset_product.branch_sites" :key="site" :value="site.id">
                          {{ $i18n.locale == "en" ? site.name_en : site.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="">
                      <label for="asset_id">{{
                        $t("fixed_assets.branch_sub_site")
                      }}</label>
                      <select class="form-select" v-model="asset_product.branch_sub_site_id">
                        <option v-for="site in asset_product.branch_sub_sites" :key="site" :value="site.id">
                          {{ $i18n.locale == "en" ? site.name_en : site.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="">
                      <label for="asset_id">{{
                        $t("fixed_assets.asset_status")
                      }}</label>
                      <select class="form-select" v-model="asset_product.fixed_asset_product_status_id">
                        <option v-for="status in AssetStatuses" :key="status" :value="status.id">
                          {{ $i18n.locale == "en" ? status.name_en : status.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.serial_no")
                    }}</label>
                    <input type="text" v-model="asset_product.serial_no" class="form-control mb-2 mx-1"
                      :placeholder="$t('fixed_assets.serial_no')" />
                  </div>
                  <div class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.alt_name")
                    }}</label>
                    <input type="text" v-model="asset_product.alt_name" class="form-control mb-2 mx-1"
                      :placeholder="$t('fixed_assets.alt_name')" />
                  </div>
                  <div class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.alt_name_en")
                    }}</label>
                    <input type="text" v-model="asset_product.alt_name_en" class="form-control mb-2 mx-1"
                      :placeholder="$t('fixed_assets.alt_name_en')" />
                  </div>

                  <div class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.initial")
                    }}</label>
                    <currency-input required v-model="asset_product.initial_book_value" class="form-control mb-2 mx-1"
                      :placeholder="$t('fixed_assets.initial')" />
                  </div>
                  <div v-if="fixed_asset?.fixed_asset_type?.depreciable" class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.accumulated_depreciation")
                    }}</label>
                    <currency-input required :max="parseFloat(asset_product?.initial_book_value)"
                      v-model="asset_product.accumulated_depreciation" class="form-control mb-2 mx-1"
                      :placeholder="$t('fixed_assets.initial')" />
                  </div>
                  <div class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.installation_date")
                    }}</label>
                    <input required v-model="asset_product.installation_date" type="date" class="form-control" />
                  </div>
                  <template v-if="fixed_asset?.fixed_asset_type?.depreciable">
                    <div class="col-12 col-md-4">
                      <label for="asset_id">{{
                        $t("fixed_assets.salvage_value")
                      }}</label>
                      <currency-input required :max="asset_product.initial_book_value"
                        v-model="asset_product.salvage_value" class="form-control mb-2 mx-1"
                        :placeholder="$t('fixed_assets.salvage_value')" />
                    </div>

                    <div class="col-12 col-md-4">
                      <label for="asset_id">{{
                        $t("fixed_assets.useful_life_years")
                      }}</label>
                      <input type="number" required v-model="asset_product.useful_life_years"
                        class="form-control mb-2 mx-1" :placeholder="$t('fixed_assets.useful_life_years')" />
                    </div>
                  </template>
                  <div class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.replacement_cost")
                    }}</label>
                    <currency-input required :max="asset_product.initial_book_value"
                      v-model="asset_product.replacement_cost" class="form-control mb-2 mx-1"
                      :placeholder="$t('fixed_assets.replacement_cost')" />
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="from-check form-check-inline">
                      <input type="checkbox" v-model="asset_product.under_warranty" :id="'under_warranty-' + index"
                        class="form-check-input" />
                      <label class="form-check-label" :for="'under_warranty-' + index">{{
                        $t("fixed_assets.under_warranty") }}</label>
                    </div>
                  </div>
                  <div class="col-12 col-md-4" v-if="asset_product.under_warranty">
                    <label for="asset_id">{{
                      $t("fixed_assets.warranty_exp")
                    }}</label>
                    <input required v-model="asset_product.warranty_exp" type="date" class="form-control" />
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="col">
                      <label for="asset_id">{{ $t("fixed_assets.rhh") }}</label>
                      <select class="form-select" v-model="asset_product.rhh">
                        <option value="R">
                          {{ $i18n.locale == "en" ? "Repaired" : "قابل للإصلاح" }}
                        </option>
                        <option value="RH">
                          {{
                            $i18n.locale == "en"
                              ? "Rehabilitated"
                              : "قابل لإعادة التأهيل"
                          }}
                        </option>
                        <option value="RHH">
                          {{
                            $i18n.locale == "en"
                              ? "Can be repaired or Rehabilitated"
                              : "قابل للإصلاح وإعادة التأهيل"
                          }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-md-4">
                    <div class="col">
                      <label for="asset_id">Pof</label>
                      <select class="form-select" v-model="asset_product.pof">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="col">
                      <label for="asset_id">Cof</label>
                      <select class="form-select" v-model="asset_product.cof">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="col">
                      <label for="asset_id">{{ $t("fixed_assets.r_f") }}</label>
                      <input v-model="asset_product.r_f" min="0" max="1" step="0.01" type="number"
                        class="form-control mb-2" :placeholder="$t('fixed_assets.r_f')" />
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="col">
                      <label for="asset_id">{{
                        $t("fixed_assets.risk_score")
                      }}</label>
                      <input v-model="asset_product.risk_score" type="text" class="form-control mb-2"
                        :placeholder="$t('fixed_assets.risk_score')" />
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <label for="asset_id">{{
                      $t("fixed_assets.additional_descr")
                    }}</label>
                    <textarea v-model="asset_product.additional_descr" class="form-control"></textarea>
                  </div>
                  <div class="col-12">
                    <label for="asset_id">{{
                      $t("fixed_assets.comment")
                    }}</label>
                    <textarea v-model="asset_product.comment" class="form-control"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'">
              <button type="submit" class="btn btn-primary">
                {{ $t("popups.add") }}
              </button>
              <button data-bs-dismiss="modal" type="button" class="btn btn-danger">
                {{ $t("popups.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--End registe Modal-->
    <!--Start register through Donator Modal-->

    <!--End register through Donator Modal-->

    <!--Start Edit Modal-->
    <div class="modal fade" id="editModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''">
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="editFixedAsset()">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                {{ $t("popups.edit") }}
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                style="margin: 0"></button>
            </div>

            <div class="modal-body">
              <div class="row">
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label for="asset_id">{{
                      $t("fixed_assets.serial_no")
                    }}</label>
                    <input required v-model="fixedAssetProduct.serial_no" type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label for="asset_id">{{
                      $t("fixed_assets.alt_name")
                    }}</label>
                    <input v-model="fixedAssetProduct.alt_name" type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group">
                    <label for="asset_id">{{
                      $t("fixed_assets.alt_name_en")
                    }}</label>
                    <input v-model="fixedAssetProduct.alt_name_en" type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="">
                    <label for="asset_id">{{
                      $t("fixed_assets.asset_status")
                    }}</label>
                    <select class="form-select" v-model="fixedAssetProduct.fixed_asset_product_status_id">
                      <option v-for="status in AssetStatuses" :key="status" :value="status.id">
                        {{ $i18n.locale == "en" ? status.name_en : status.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- d -->

                <div class="col-12 col-md-6">
                  <div class="form-group form-check">
                    <input type="checkbox" v-model="fixedAssetProduct.under_warranty" id="under_warranty"
                      class="form-check-input" />
                    <label class="form-check-label" for="under_warranty">{{
                      $t("fixed_assets.under_warranty")
                    }}</label>
                  </div>
                </div>
                <div class="col-12 col-md-6" v-if="fixedAssetProduct.under_warranty">
                  <div class="form-group">
                    <label for="asset_id">{{
                      $t("fixed_assets.warranty_exp")
                    }}</label>
                    <input v-model="fixedAssetProduct.warranty_exp" type="date" class="form-control" />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="col">
                    <label for="asset_id">{{ $t("fixed_assets.rhh") }}</label>
                    <select class="form-select" v-model="fixedAssetProduct.rhh">
                      <option value="R">
                        {{ $i18n.locale == "en" ? "Repaired" : "قابل للإصلاح" }}
                      </option>
                      <option value="RH">
                        {{
                          $i18n.locale == "en"
                            ? "Rehabilitated"
                            : "قابل لإعادة التأهيل"
                        }}
                      </option>
                      <option value="RHH">
                        {{
                          $i18n.locale == "en"
                            ? "Can be repaired or Rehabilitated"
                            : "قابل للإصلاح وإعادة التأهيل"
                        }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="col">
                    <label for="asset_id">Pof</label>
                    <select class="form-select" v-model="fixedAssetProduct.pof">
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="col">
                    <label for="asset_id">Cof</label>
                    <select class="form-select" v-model="fixedAssetProduct.cof">
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="col">
                    <label for="asset_id">{{ $t("fixed_assets.r_f") }}</label>
                    <input v-model="fixedAssetProduct.r_f" min="0" max="1" step="0.01" type="number"
                      class="form-control mb-2" :placeholder="$t('fixed_assets.r_f')" />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.risk_score")
                    }}</label>
                    <input v-model="fixedAssetProduct.risk_score" type="text" class="form-control mb-2"
                      :placeholder="$t('fixed_assets.risk_score')" />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <label for="asset_id">{{
                    $t("fixed_assets.additional_descr")
                  }}</label>
                  <textarea v-model="fixedAssetProduct.additional_descr" class="form-control"></textarea>
                </div>
                <div class="col-12 ">
                  <div class="form-group">
                    <label for="asset_id">{{
                      $t("fixed_assets.comment")
                    }}</label>
                    <textarea v-model="fixedAssetProduct.comment" class="form-control"></textarea>
                  </div>
                </div>

              </div>
            </div>
            <div class="modal-footer" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'">
              <button type="submit" class="btn btn-primary">
                {{ $t("popups.edit") }}
              </button>
              <button data-bs-dismiss="modal" type="button" class="btn btn-danger">
                {{ $t("popups.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--End Edit Modal-->

    <!-- Dispose Modal -->
    <div class="modal fade" id="disposeModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''">
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="doDispose">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                {{
                  this.$i18n.locale == "ar" ? "القيمة الحالية" : "Current Value"
                }}
                {{ parseFloat(remaining_value).toLocaleString() }}
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                style="margin: 0"></button>
            </div>

            <div class="modal-body">
              <div class="row">
                <div class="row mb-2">
                  <label for="asset_id">{{
                    $t("fixed_assets.disposal_type")
                  }}</label>
                  <div class="col mt-2">
                    <div v-for="(type, index) in this.fixed_asset_disposal_types" :key="index"
                      class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="" v-model="disposal_type_code"
                        @change="disposed_asset.value = 0" :value="type.code" />
                      <label class="form-check-label" for="">{{
                        $i18n.locale == "en" ? type.name_en : type.name
                      }}</label>
                    </div>
                  </div>
                </div>
                <!-- Dispose Value -->
                <div class="row align-items-center mb-2">
                  <div class="col">
                    <label for="asset_id">{{
                      $t("fixed_assets.sell_value")
                    }}</label>
                    <currency-input :disabled="disposal_type_code == 'damaged' ? true : false"
                      v-model="disposed_asset.value" class="form-control mb-2" />
                  </div>
                </div>
                <template v-if="disposal_type_code == 'sale'">
                  <div class="row align-items-center">
                    <div class="col">
                      <label for="asset_id">{{
                        $t("fixed_assets.chose_account")
                      }}</label>
                    </div>
                    <div class="col d-flex justify-content-end">
                      <button v-if="addAsset.length < 3" type="button" @click="addAsset.push({})" class="btn float-end">
                        <span class="bx bxs-plus-circle float-end fa-2x" style="color: #2a3042 !important"></span>
                      </button>
                    </div>
                  </div>
                  <div v-for="(asset, addAssetIndex) in addAsset" :key="asset">
                    <div class="row my-3">
                      <div class="d-flex justify-content-between">
                        <select v-model="asset.cash_account" class="form-select mb-2" id="asset_id"
                          :placeholder="$t('fixed_assets.accounts')">
                          <option v-for="cashAccount in cashAccounts" :key="cashAccount" :value="cashAccount">
                            {{
                              $i18n.locale == "ar"
                                ? cashAccount?.name
                                : cashAccount?.name_en
                            }}
                            - ({{
                              parseFloat(cashAccount.balance).toLocaleString()
                            }})
                          </option>
                        </select>
                        <currency-input v-model="asset.value" class="form-control mb-2 mx-1"
                          :placeholder="$t('emps.amount')" />
                        <span class="mx-2">
                          <button class="btn btn-danger" @click="addAsset.splice(addAssetIndex, 1)"
                            v-if="addAsset.length > 1">
                            <i class="bx bx-trash"></i>
                          </button>
                          <button v-else disabled class="btn btn-danger">
                            <i class="bx bx-trash"></i>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="modal-footer" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'">
              <button :disabled="disposed_asset.value != totalDisposalAccountsValue" type="submit"
                class="btn btn-primary">
                {{ $t("fixed_assets.disposal") }}
              </button>
              <button data-bs-dismiss="modal" type="button" class="btn btn-danger">
                {{ $t("popups.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Dispose Modal End -->
    <!-- reEvaluteModal Modal -->
    <div class="modal fade" id="reEvaluteModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
      :dir="$i18n.locale == 'ar' ? 'rtl' : ''">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <form @submit.prevent="reEvaluteAsset">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                {{ $t("fixed_assets.asset_revaluation") }}
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                style="margin: 0"></button>
            </div>

            <div class="modal-body">
              <div class="row mb-3">
                <div class="col-6">
                  <label for="asset_id">{{
                    $t("fixed_assets.reference_no")
                  }}</label>
                  <input type="text" v-model="revaluate_value.reference_no" class="form-control" />
                </div>
              </div>
              <div class="row">
                <!-- reEvalute Value -->
                <div class="col-12 col-md-6 mb-2">
                  <label for="asset_id">{{ $t("fixed_assets.initial") }}</label>
                  <currency-input disabled v-model="revaluation_asset.initial_book_value" class="form-control" />
                </div>
                <div class="col-12 col-md-6 mb-2">
                  <label for="asset_id">{{
                    $t("fixed_assets.revaluted_book_value")
                  }}</label>
                  <currency-input v-model="revaluate_value.revaluted_book_value" class="form-control mb-2" requried />
                </div>
                <div class="col-12 col-md-6 mb-2">
                  <label for="asset_id">{{
                    $t("fixed_assets.salvage_value")
                  }}</label>
                  <currency-input disabled v-model="revaluation_asset.salvage_value" class="form-control" />
                </div>
                <div class="col-12 col-md-6 mb-2">
                  <label for="asset_id">{{
                    $t("fixed_assets.revaluted_salvage_value")
                  }}</label>
                  <currency-input v-model="revaluate_value.revaluted_salvage_value" class="form-control mb-2" />
                </div>
                <div class="col-12 col-md-6 mb-2">
                  <label for="asset_id">{{
                    $t("fixed_assets.replacement_cost")
                  }}</label>
                  <currency-input disabled v-model="revaluation_asset.replacement_cost" class="form-control" />
                </div>
                <div class="col-12 col-md-6 mb-2">
                  <label for="asset_id">{{
                    $t("fixed_assets.revaluted_replacement_cost")
                  }}</label>
                  <currency-input v-model="revaluate_value.revaluted_replacement_cost" class="form-control mb-2" />
                </div>

                <div class="col-12 col-md-6 mb-2">
                  <label for="asset_id">{{
                    $t("fixed_assets.useful_life_years")
                  }}</label>
                  <currency-input disabled v-model="revaluation_asset.useful_life_years" class="form-control" />
                </div>
                <div class="col-12 col-md-6 mb-2">
                  <label for="asset_id">{{
                    $t("fixed_assets.revaluted_useful_life_years")
                  }}</label>
                  <currency-input v-model="revaluate_value.revaluted_useful_life_years" class="form-control mb-2" />
                </div>
              </div>
            </div>
            <div class="modal-footer" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'">
              <button type="submit" class="btn btn-primary">
                {{ $t("fixed_assets.revalue") }}
              </button>
              <button data-bs-dismiss="modal" type="button" class="btn btn-danger">
                {{ $t("popups.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- reEvaluteModal Modal End -->

    <div class="modal fade" id="hrCustodyModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId"
      aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <form @submit.prevent="addHrCustody()">
            <div class="modal-header">
              <h5 class="modal-title">
                {{ $t("hr_custodies.add_custody") }}
              </h5>
              <button type="button" class="close" @click="add_custody_modal.hide()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="" class="form-label">{{
                  $t("hr_custodies.fixed_asset")
                }}</label>
                <AutoComplete v-model="hr_custody.fixed_asset_product" :suggestions="fixed_assets"
                  @complete="searchFixedAssetsForCustody($event.query)" :complete-on-focus="true"
                  :optionLabel="showLabel" class="w-100" :input-class="'form-control w-100'" />
              </div>
              <div class="mb-3">
                <label for="" class="form-label">{{
                  $t("hr_custodies.emp_name")
                }}</label>
                <AutoComplete v-model="hr_custody.emp" :suggestions="emps" @complete="searchEmployees($event.query)"
                  :complete-on-focus="true" :optionLabel="showEmpLabel" :inputClass="'form-control'" class="w-100" />
              </div>
              <div class="mb-3">
                <label for="" class="form-label">{{
                  $t("fixed_assets.reference_no")
                }}</label>
                <input type="text" class="form-control" v-model="hr_custody.reference_no" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" @click="this.add_custody_modal.hide()" class="btn btn-light">
                {{ $t("popups.cancel") }}
              </button>
              <button :disabled="!(hr_custody?.fixed_asset_product?.id && hr_custody?.emp?.id)
                " type="submit" class="btn btn-primary">
                {{ $t("popups.add") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal Body -->
    <!-- if you want to close by clicking outside the modal, delete the last endpoint:data-bs-backdrop and data-bs-keyboard -->
    <div class="modal fade" id="transferModal" tabindex="-1" role="dialog" aria-labelledby="modalTitleId"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalTitleId">
              {{ $t("fixed_assets.transfer") }}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form @submit.prevent="doTransfer()">
            <div class="modal-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12">
                    <label for="asset_id">{{
                      $t("fixed_assets.transfer_to")
                    }}</label>
                    <select required class="form-select" v-model="transfer_data.to_branch_id" @change="
                      getBranchSitesTransfer(transfer_data.to_branch_id)
                      ">
                      <option v-for="branch in company_branches" :key="branch" :value="branch.id">
                        {{
                          $i18n.locale == "en" ? branch.name_en : branch.name
                        }}
                      </option>
                    </select>
                  </div>
                  <div class="col-12">
                    <div class="">
                      <label for="asset_id">{{
                        $t("fixed_assets.branch_site")
                      }}</label>
                      <select class="form-select" v-model="transfer_data.branch_site_id">
                        <option v-for="site in branch_sites" :key="site" :value="site.id">
                          {{ $i18n.locale == "en" ? site.name_en : site.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">
                {{ $t("hr_custodies.transfer_logs.transfer") }}
              </button>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                {{ $t("popups.colse") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="modal fade" id="transferHrCustodyModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId"
      aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <form @submit.prevent="transferHrCustody()">
            <div class="modal-header">
              <h5 class="modal-title">
                {{ $t("hr_custodies.search_emps") }}
              </h5>
              <button type="button" class="close" @click="transfer_hr_custody_modal.hide()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label for="" class="form-label">{{
                  $t("hr_custodies.emp_name")
                }}</label>
                <AutoComplete v-model="hr_custody.emp" :suggestions="emps" @complete="searchEmployees($event.query)"
                  :complete-on-focus="true" :optionLabel="showEmpLabel" :inputClass="'form-control'" class="w-100" />
              </div>
              <div class="mb-3">
                <label for="" class="form-label">{{
                  $t("fixed_assets.reference_no")
                }}</label>
                <input type="text" class="form-control" v-model="hr_custody.reference_no" />
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" @click="this.transfer_hr_custody_modal.hide()" class="btn btn-light">
                {{ $t("popups.cancel") }}
              </button>
              <button :disabled="!(hr_custody?.emp && hr_custody?.emp?.id)" type="submit" class="btn btn-primary">
                {{ $t("popups.transfer") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--   Apps  Pagination     -->
    <div>
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a class="page-link" href="javascript: void(0);" @click="
            search
              ? searchFixedAssetProducts(page - 1)
              : getFixedAssetProductsPagination(page - 1)
            " aria-label="Previous">
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li class="page-item" :class="{ active: p == page }" v-for="p in tot_pages" :key="p">
          <a class="page-link" href="javascript: void(0);" @click="
            search
              ? searchFixedAssetProducts(p)
              : getFixedAssetProductsPagination(p)
            ">{{ p }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == tot_pages }">
          <a class="page-link" href="javascript: void(0);" @click="
            search
              ? searchFixedAssetProducts(page + 1)
              : getFixedAssetProductsPagination(page + 1)
            " aria-label="Next">
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.purchase-container {
  background: #fafafa;
  margin: 1rem;
  border-radius: 0.5rem;
  padding: 1rem;
}

.balance-table tr td {
  vertical-align: middle;
  padding: 12px 10px;
}

.balance-table tr th {
  vertical-align: middle;
  padding: 15px 10px;
}

.trash-icon-width {
  width: 24px;
}
</style>
